import { formatTokenAmount, formatUsd } from '@dapp/multi-lib/lib/formatters';

interface VaultPositionDisplayParams {
  underlyingAssets: bigint;
  underlyingAssetDecimals: number;
  underlyingAssetSymbol: string;
  positionInUsd: number | string;
}

export const hasVaultPosition = (walletBalance?: bigint | null) =>
  (walletBalance ?? BigInt(0)) > BigInt(0);

export const getVaultPositionDisplay = (params: VaultPositionDisplayParams) => {
  const {
    underlyingAssets,
    underlyingAssetDecimals,
    underlyingAssetSymbol,
    positionInUsd,
  } = params;
  const fractionDigits = Math.min(underlyingAssetDecimals, 8);
  const underlyingAmount = formatTokenAmount(
    underlyingAssets,
    underlyingAssetDecimals,
    fractionDigits
  );
  const usdAmount = formatUsd(positionInUsd);

  if (parseFloat(underlyingAmount) === 0 && usdAmount === '0.00') {
    return null;
  }

  return { underlyingAmount, underlyingAssetSymbol, usdAmount };
};
